import { TableParameters } from '../../../component-library/table/table-parameters';
import { CONFIG } from '../../../core/config';
import { ViewModel } from '../../view-model';
import { TableTemplate } from './table-template';
import { TableTemplateColumn } from './table-template-column';

export class TableTemplateSaveData implements ViewModel {
  public friendlyTypeNameSingular: string = 'Table Template Save Data';
  public apiRoute: string = CONFIG.apiRoutes.tableTemplateSave;

  public tableTemplateInfo: TableTemplate;
  public columns: TableTemplateColumn[] = [];
  public attributesTableParameters: TableParameters;
  public totalColumnsCount: number = 0;

  public json(): this {
    return this;
  }

  public loadFromJson(data: any): void {
    if (data.tableTemplateInfo) {
      this.tableTemplateInfo = new TableTemplate();
      this.tableTemplateInfo.loadFromJson(data.tableTemplateInfo);
    }

    if (data.columns) {
      for (const item of data.columns) {
        const column = new TableTemplateColumn();

        column.loadFromJson(item);
        this.columns.push(column);
      }
    }

    this.attributesTableParameters = data.attributesTableParameters;
    this.totalColumnsCount = data.totalColumnsCount;
  }
}
